import Vue from "vue";

import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QItem from 'quasar/src/components/item/QItem.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QBar from 'quasar/src/components/bar/QBar.js';import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import QCard from 'quasar/src/components/card/QCard.js';import QCarousel from 'quasar/src/components/carousel/QCarousel.js';import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QChip from 'quasar/src/components/chip/QChip.js';import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';import QDate from 'quasar/src/components/date/QDate.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QEditor from 'quasar/src/components/editor/QEditor.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QField from 'quasar/src/components/field/QField.js';import QFile from 'quasar/src/components/file/QFile.js';import QUploader from 'quasar/src/components/uploader/QUploader.js';import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';import QAjaxBar from 'quasar/src/components/ajax-bar/QAjaxBar.js';import QForm from 'quasar/src/components/form/QForm.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QImg from 'quasar/src/components/img/QImg.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QInput from 'quasar/src/components/input/QInput.js';import QList from 'quasar/src/components/item/QList.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QTable from 'quasar/src/components/table/QTable.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QSpinnerPuff from 'quasar/src/components/spinner/QSpinnerPuff.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QTr from 'quasar/src/components/table/QTr.js';import QTd from 'quasar/src/components/table/QTd.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QFab from 'quasar/src/components/fab/QFab.js';import QFabAction from 'quasar/src/components/fab/QFabAction.js';import QFooter from 'quasar/src/components/footer/QFooter.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QSplitter from 'quasar/src/components/splitter/QSplitter.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QTh from 'quasar/src/components/table/QTh.js';import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import QPagination from 'quasar/src/components/pagination/QPagination.js';import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';;



const component = {
  "q-avatar": QAvatar,
  "q-item": QItem,
  "q-badge": QBadge,
  "q-banner": QBanner,
  "q-bar": QBar,
  "q-breadcrumbs": QBreadcrumbs,
  "q-btn": QBtn,
  "q-btn-group": QBtnGroup,
  "q-btn-toggle": QBtnToggle,
  "q-card": QCard,
  "q-carousel": QCarousel,
  "q-chat-message": QChatMessage,
  "q-checkbox": QCheckbox,
  "q-chip": QChip,
  "q-circular-progress": QCircularProgress,
  "q-date": QDate,
  "q-dialog": QDialog,
  "q-edit": QEditor,
  "q-expansion-item": QExpansionItem,
  "q-field": QField,
  "q-file": QFile,
  "q-uploader": QUploader,
  "q-virtul-scroll": QVirtualScroll,
  "q-ajax-bar": QAjaxBar,
  "q-form": QForm,
  "q-icon": QIcon,
  "q-img": QImg,
  "q-input": QInput,
  "q-list": QList,
  "q-menu": QMenu,
  "q-option-group": QOptionGroup,
  "q-radio": QRadio,
  "q-select": QSelect,
  "q-space": QSpace,
  "q-table": QTable,
  "q-table-panels": QTabPanels,
  "q-layout": QLayout,
  "q-spinner-puff": QSpinnerPuff,
  "q-header": QHeader,
  "q-toolbar": QToolbar,
  "q-toolbar-title": QToolbarTitle,
  "q-btn-dropdown": QBtnDropdown,
  "q-item-section": QItemSection,
  "q-separator": QSeparator,
  "q-drawer": QDrawer,
  "q-scroll-area": QScrollArea,
  "q-page-container": QPageContainer,
  "q-card-section": QCardSection,
  "q-tr": QTr,
  "q-td": QTd,
  "q-toggle": QToggle,
  "q-fab": QFab,
  "q-fab-action": QFabAction,
  "q-footer": QFooter,
  "q-card-actions": QCardActions,
  "q-linear-progress": QLinearProgress,
  "q-page-sticky": QPageSticky,
  "q-tooltip": QTooltip,
  "q-splitter": QSplitter,
  "q-tabs": QTabs,
  "q-tab": QTab,
  "q-tab-panels": QTabPanels,
  "q-tab-panel": QTabPanel,
  "q-th": QTh,
  "q-slide-transition": QSlideTransition,
  "q-item-label": QItemLabel,
  "q-spinner-ios": QSpinnerIos,
  "q-carousel-slide": QCarouselSlide,
  'q-inner-loading': QInnerLoading,
  'q-spinner-bars': QSpinnerBars,
  "q-spinner": QSpinner,
  "q-pagination": QPagination,
  "q-breadcrumbs-el": QBreadcrumbsEl,

};

for (let c in component) {
  Vue.component(c, component[c]);
}
